<script lang="ts" module>
	import type { Snippet } from 'svelte';
	import type { ClassValue, HTMLAttributes } from 'svelte/elements';
	import type { VariantProps } from 'tailwind-variants';
	import { tv } from '../tv';

	export const lineVariants = tv({
		base: 'relative flex items-center justify-center border-solid',
		variants: {
			variant: {
				Inherit: 'border-inherit',
				Background: 'border-(--v-container-line) variant-background',
				Surface: 'border-(--v-container-line) variant-surface',
				SurfaceVariant: 'border-(--v-container-line) variant-surface-variant',
				Primary: 'border-(--v-container-line) variant-primary',
				Secondary: 'border-(--v-container-line) variant-secondary',
				Success: 'border-(--v-container-line) variant-success',
				Warning: 'border-(--v-container-line) variant-warning',
				Critical: 'border-(--v-container-line) variant-critical'
			},
			direction: {
				Horizontal: 'h-s0 border-b-(length:--line-width)',
				Vertical: 'w-s0 flex-col border-l-(length:--line-width)'
			},
			size: {
				'300': '[--line-width:var(--border-width-b300)]',
				'400': '[--line-width:var(--border-width-b400)]',
				'500': '[--line-width:var(--border-width-b500)]',
				'600': '[--line-width:var(--border-width-b600)]',
				'700': '[--line-width:var(--border-width-b700)]'
			}
		},
		defaultVariants: { variant: 'Surface', direction: 'Horizontal', size: '400' }
	});

	export interface LineProps
		extends Omit<HTMLAttributes<HTMLElement>, 'class'>, VariantProps<typeof lineVariants> {
		as?: string;
		children?: Snippet;
		class?: ClassValue;
		ref?: HTMLElement | null;
	}
</script>

<script lang="ts">
	let {
		as = 'div',
		children,
		class: className,
		direction,
		ref = $bindable(null),
		size,
		variant,
		...rest
	}: LineProps = $props();
</script>

<svelte:element
	this={as}
	bind:this={ref}
	class={[lineVariants({ direction, size, variant }), className]}
	{...rest}
>
	{@render children?.()}
</svelte:element>
